import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Classes from "./pages/Classes";
import Systems from "./pages/Systems";
import Resources from "./pages/Resources";
import BruceLee from "./pages/BruceLee";
import Wong from "./pages/Wong";
import Photos from "./pages/Photos";
import Library from "./pages/Library";
import BBS from "./pages/BBS";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <Routes>
          <Route
            path=""
            element={
              <>
                <Home />
              </>
            }
          />{" "}
          <Route
            path="/"
            element={
              <>
                <Home />
              </>
            }
          />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/systems" element={<Systems />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/brucelee" element={<BruceLee />} />
          <Route path="/wong" element={<Wong />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/discuss" element={<BBS />} />
          <Route path="/library" element={<Library />} />
        </Routes>
        <br />
        <br />
        <br />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
